import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo-1.png";
import { FaWhatsapp, FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";

const Nav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Optional: Prevent scrolling when menu is open
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "auto";
  }, [isMobileMenuOpen]);

  const handleClick = () => {
    if (window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'WhatsApp',
        event_label: 'Click on WhatsApp Chat Button',
        value: 1,
      });
    }
  };

  const handleCall = () => {
    if (window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'Call',
        event_label: 'Click on Call Button',
        value: 1,
      });
    }
  };

  return (
    <>
      <nav className="bg-white shadow-lg fixed top-0 left-0 w-full z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-3 h-[75px]">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img src={logo} alt="Bharat Tour" className="h-[70px] w-auto p-1" />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-10">
              <Link to="/" className="text-gray-900 font-medium hover:text-pink-600 transition">Home</Link>
              <Link to="/about" className="text-gray-900 font-medium hover:text-pink-600 transition">About</Link>
              <Link to="/packages" className="text-gray-900 font-medium hover:text-pink-600 transition">Tour Packages</Link>
              <Link to="/taxi-service" className="text-gray-900 font-medium hover:text-pink-600 transition">Taxi Service</Link>
              <Link to="/contact" className="text-gray-900 font-medium hover:text-pink-600 transition">Contact</Link>
            </div>

            {/* WhatsApp Button (Desktop) */}
            <div className="hidden md:flex">
              <a
                href="https://wa.me/9116710874"
                target="_blank"
                rel="noopener noreferrer"
                className="flex bg-pink-600 rounded-full items-center space-x-2 py-2 px-4 text-white hover:bg-pink-500 transition"
              >
                <FaWhatsapp className="text-xl" />
                <span>Connect</span>
              </a>
            </div>

            {/* Mobile Menu Toggle Button */}
            <button
              className="md:hidden text-gray-900 text-2xl"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden fixed top-[75px] left-0 w-full bg-white z-40 transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? "translate-y-0" : "-translate-y-[150%]"
            }`}
        >
          <Link
            to="/"
            className="block py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/about"
            className="block py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/packages"
            className="block py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Tour Packages
          </Link>
          <Link
            to="/taxi-service"
            className="block py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Taxi Service
          </Link>
          <Link
            to="/contact"
            className="block py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contact
          </Link>
          <a
            href="https://wa.me/51597"
            target="_blank"
            rel="noopener noreferrer"
            className="flex bg-pink-600 mx-6 my-4 rounded-full items-center space-x-2 py-2 px-4 text-white hover:bg-pink-500 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FaWhatsapp className="text-xl" />
            <span>Connect</span>
          </a>
        </div>
      </nav>
      {/* Floating WhatsApp & Call Buttons */}
      <div className="fixed bottom-4 right-4 flex flex-col items-end space-y-3 z-50">
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/9116710874"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition"
          aria-label="Chat on WhatsApp"
          onClick={handleClick}
        >
          <FaWhatsapp className="text-2xl" />
        </a>

        {/* Call Button */}
        <a
          href="tel:9116710874"
          className="bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition"
          aria-label="Call now"
          onClick={handleCall}
        >
          <FaPhoneAlt className="text-2xl" />
        </a>
      </div>
    </>
  );
};
export default Nav;